@if (isOpen()) {
  <div class="eva-sidebar"
       [class.expanded]="isExpanded()"
       [class.closing]="isClosing()">
    <ez-eva-sidebar-header />
    <ez-eva-sidebar-content />
  </div>
}